module.exports = __webpack_public_path__ + "static/media/domino2-copy.23301a68.jpg";